import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { environmentBanner, environmentTabTitle, EnvironmentFacts } from './environment-banner';

/** Root class while a banner shows: the banner then owns the status-bar inset (global-styles `--ng-top-inset`). */
export const ENV_BANNER_ROOT_CLASS = 'ng-env-banner-on';

/**
 * The strip at the very top of every screen off the live system (ISS-032), sign-in page included.
 * It sits in the app shell's flow above everything else, so no screen can cover it except a dialog.
 */
@Component({
    selector: 'newgenus-environment-banner',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (banner) {
            <div class="env-banner env-banner--{{ banner.tone }}" role="status" data-testid="env-banner">
                <span class="env-banner__label">{{ banner.label }}</span>
                <span class="env-banner__message env-banner__message--long">{{ banner.message }}</span>
                <span class="env-banner__message env-banner__message--short">Not the live system</span>
                <a class="env-banner__live" [href]="banner.liveUrl" target="_blank" rel="noopener">Go to live ›</a>
            </div>
        }
    `,
    styleUrls: ['./environment-banner.component.scss'],
})
export class EnvironmentBannerComponent implements OnInit {
    /** Overridable in tests; the app reads its build's environment. */
    facts: EnvironmentFacts = { env: environment.env, useEmulators: environment.useEmulators };
    banner = environmentBanner(this.facts);

    constructor(
        private readonly title: Title,
        @Inject(DOCUMENT) private readonly document: Document
    ) {}

    ngOnInit(): void {
        this.banner = environmentBanner(this.facts);
        this.document.documentElement.classList.toggle(ENV_BANNER_ROOT_CLASS, !!this.banner);
        this.title.setTitle(environmentTabTitle(this.title.getTitle(), this.facts));
    }
}
